import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import {
  faArrowLeft,
  faArrowRight,
  faHome,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import {
  Container,
  Col,
  Row,
  Card,
  Form,
  Button,
  Breadcrumb,
  Nav,
  Tab,
} from "@themesberg/react-bootstrap";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import UpdateApplicationStatus from "../../components/UpdateApplicationStatus";
import BASE_URL from "../../config";








const EditApplication = () => {
  
  
   const [messages, setMessages] = useState([]);
 
  const [userType, setUserType] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [statusUpdated, setStatusUpdated] = useState(false);
 const [userId, setUserId]= useState (null);
  const [loading, setLoading] = useState(true);
  const [applicationData, setApplicationData] = useState({});


  
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("authToken"));
    if (user) {
      setUserId(user.id);
      setUserType(user.user_type);
    }
  }, []);



  const formatMessages = (messages) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
  
    const groupedMessages = [];
  
    let currentGroup = null;
  
    messages.forEach((message) => {
      
      const messageDate = new Date(message.time);

      let groupDate = '';
  
      // Check if the message is from today, yesterday, or earlier
      if (isSameDay(messageDate, today)) {
        groupDate = 'Today';
      } else if (isSameDay(messageDate, yesterday)) {
        groupDate = 'Yesterday';
      } else {
        groupDate = messageDate.toLocaleDateString(); // Show actual date for older messages
      }
  
      // If the group doesn't exist, create a new one
      if (!currentGroup || currentGroup.date !== groupDate) {
        if (currentGroup) groupedMessages.push(currentGroup);
        currentGroup = { date: groupDate, messages: [] };
      }
  
      
      currentGroup.messages.push(message);
    });
  
    if (currentGroup) groupedMessages.push(currentGroup); // Add the last group
  
    return groupedMessages;
  };
  
  // Helper function to check if two dates are on the same day
  const isSameDay = (date1, date2) => {
    return date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear();
  };
  








  // Handle sending new messages
  const handleSendMessage = async () => {
    if (newMessage.trim()) {
      // Create a temporary message object for immediate UI rendering
      const tempMessage = {
        id: Date.now(), // Temporary unique ID for the message
        text: newMessage,
        time: new Date(), // Current timestamp
        sender: true, // Defaulting sender to true for user messages
      };
  
      // Optimistically update the UI
      setMessages((prevMessages) => [...prevMessages, tempMessage]);
      setNewMessage(""); // Clear the input after sending
  
      try {
        const response = await axios.post(`${BASE_URL}/api.php`, {
          type: "AddMessage",
          user_id: userId,
          message: newMessage,
          application_id: applicationData.id,
          loggedInUserId:userId

        });
  
        if (response.data.status === "success") {
          // Update the message ID with the one returned by the backend
          setMessages((prevMessages) =>
            prevMessages.map((msg) =>
              msg.id === tempMessage.id
                ? { ...msg, id: response.data.message_id }
                : msg
            )
          );
  
          // Handle sending notifications
          try {
            const usersResponse = await axios.get(`${BASE_URL}/api.php?type=users`);
            const allUsers = Array.isArray(usersResponse.data)
              ? usersResponse.data
              : [];
  
            const targetEmails =
              userType == 2
                ? allUsers
                    .filter(
                      (user) => user.user_type === "0" || user.user_type === "1"
                    )
                    .map((user) => user.email)
                : [applicationData.user_email]; // For userType 0 or 1, use the applicant's email
  
            for (const email of targetEmails) {
              const notificationPayload = {
                type: "AddNotification",
                email: email,
                title: `New Message In Application id ${applicationData.id}`,
                message: newMessage,
              };
  
              await axios.post(`${BASE_URL}/api.php`, notificationPayload);
            }
  
            // alert("Notifications sent successfully!");
          } catch (error) {
            console.error("Error sending notifications:", error);
            alert("Error sending notifications.");
          }
        } else {
          alert(response.data.error || "Failed to add the message.");
          // Remove the temporary message from the UI
          setMessages((prevMessages) =>
            prevMessages.filter((msg) => msg.id !== tempMessage.id)
          );
        }
      } catch (error) {
        console.error("Error sending message:", error);
        alert("Error sending the message.");
        // Remove the temporary message from the UI
        setMessages((prevMessages) =>
          prevMessages.filter((msg) => msg.id !== tempMessage.id)
        );
      }
    }
  };

  const fetchMessages = async () => {
    try {
      // console.log(userId,applicationData.user_email);
      
      // Check if userId and applicationData.user_email are available before making API call
      if (!userId || !applicationData.user_email) {
        console.error("userId or user_email is missing.");
        return;
      }
  
      const response = await axios.post(`${BASE_URL}/api.php`, {
        type: "GetMessagesByUsers",
        loggedin_user_id: userId,
        application_id:applicationData.id // No changes here
      });
   

      // console.log(response.data.applicant_user_messages);
      // console.log(response.data.loggedin_user_messages);

      // console.log(response.data)
      
      if (response.data.status === "success") {
        const messages = response.data.messages.map((msg) => ({
          id: msg.id,
          text: msg.message,
          time: new Date(msg.created_at), // Store actual date object for sorting
          sender: msg.user_id === userId, // Defaults to false if condition is not met
          senderName: msg.sender_name, 
        }));
         
       
        
        // const applicantMessages = response.data.applicant_user_messages.map((msg) => ({
        //   id: msg.id,
        //   text: msg.message,
        //   time: new Date(msg.created_at), // Store actual date object for sorting
        //   sender: false, // Marking as sent by the applicant
        // }));
  
        // Combine messages
        
      //  const message = data.response.messages
        // const allMessages = [
        //   ...loggedinMessages,
        //   ...applicantMessages,
        // ];
  
        setMessages((prevMessages) => {
          const allMessages = [...prevMessages, ...messages];
          // Sort messages by time in ascending order
          allMessages.sort((a, b) => a.time - b.time);
          return allMessages;
        });
        
      } else {
        console.error(response.data.error || "Failed to fetch messages.");
        alert("Failed to fetch messages.");
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
      alert("Error fetching messages.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!userId || !applicationData.user_email) {
      console.error("userId or user_email is missing.");
      return; // Don't fetch if either value is missing
    }
  
    fetchMessages(); // Only call fetchMessages when both values are available
  }, [userId, applicationData.user_email]);



  
  
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault(); // Prevent adding a newline
      handleSendMessage();
    }
  };
  
  
  
  // Callback to handle status update
  const handleStatusUpdate = () => {
    setStatusUpdated(true);
  };

  
  // useEffect(() => {
    //   const user = JSON.parse(localStorage.getItem("authToken"));
    //   if (user) {
      //     setUserType(user.user_type);
      //   }
      // }, []);
      
      
      
      
      
      
      
      
      const { id } = useParams(); // Get application ID from URL
      const [formData, setFormData] = useState({
        user_type: "",
        application_status: "",
        company_name: "",
        company_address: "",
        website_url: "",
        manager_full_name: "",
        bank_account_number: "",
        additional_information: "",
        // Add all fields you will use in formData
      });
      
      const [activeTab, setActiveTab] = useState("Merchant"); // State to manage active tab
      const [errors, setErrors] = useState({});
      
      // Fetch application data based on the ID
      useEffect(() => {
      const fetchApplicationData = async () => {
        try {
          const response = await axios.get(
            `${BASE_URL}/api.php?type=getApplicationById&id=${id}`
          );

          console.log("Application API response:", response.data);

          setApplicationData(response.data);

          // IMPORTANT: Populate form fields
          setFormData(response.data);

          setLoading(false);
        } catch (error) {
          console.error("Error fetching application data:", error);
          setLoading(false);
        }
      };

      if (id) {
        fetchApplicationData();
      }
    }, [id, statusUpdated]);
    
      // Fetch user information on component mount
  //     useEffect(() => {
  //       // Fetch application data by ID for editing
  //       const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `/api.php?type=getApplicationById&id=${id}`
  //       );
  //       setFormData(response.data);
  //     } catch (error) {
  //       console.error("Error fetching application data:", error);
  //     }
  //   };
  //   fetchData();
  // }, [id,statusUpdated]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNextClick = () => {
    // Define the fields required for each tab
    const requiredFields = {
      Merchant: ["user_type", "application_status"],
      Company: ["company_name", "company_address", "company_zipcode", "company_country"],
      Website: ["website_url"],
      Manager: ["manager_full_name", "manager_address"],
      Customer: ["contactname", "contactemail"],
      Processing: [],
      Transaction: ["total_sales", "no_of_trans_per_mnth"],
      Bank: [
        "account_holder_name",
        "bank_name",
        "bank_address",
        "bank_country",
        "bank_swift",
        "bank_routing_no",
        "bank_account_no",
        "bank_additional_info",
      ],
      Other: ["about_us", "agent_name"],
    };

    // Validate fields for the current tab
    const currentTabFields = requiredFields[activeTab] || [];
    const validationErrors = validateForm(currentTabFields);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors); // Set validation errors
      return; // Stop navigation if there are errors
    }

    // Define the tab order
    const tabs = [
      "Merchant",
      "Company",
      "Website",
      "Manager",
      "Customer",
      "Processing",
      "Transaction",
      "Bank",
      "Other",
    ];

    // Get the index of the current tab and move to the next one
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex < tabs.length - 1) {
      setActiveTab(tabs[currentIndex + 1]);
    }
  };

  const handlePreviousClick = () => {
    switch (activeTab) {
      case "Company":
        setActiveTab("Merchant");
        break;
      case "Website":
        setActiveTab("Company");
        break;
      case "Manager":
        setActiveTab("Website");
        break;
      case "Customer":
        setActiveTab("Manager");
        break;
      case "Processing":
        setActiveTab("Customer");
        break;
      case "Transaction":
        setActiveTab("Processing");
        break;
      case "Bank":
        setActiveTab("Transaction");
        break;
      case "Other":
        setActiveTab("Bank");
        break;
      default:
        setActiveTab("Other");
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`${BASE_URL}/api.php`, {
        ...formData,
        type: "applications",
        id,
      });

      if (
        response.status === 200 &&
        response.data.status === "Application updated successfully"
      ) {
        alert("Application updated successfully");
      } else {
        console.error("Unexpected response:", response);
        alert("Failed to update application. Please try again.");
      }
    } catch (error) {
      console.error("Error updating application:", error);
    }
  };

  const validateForm = (fieldsToValidate = []) => {
    const patterns = {
      phone: /^[0-9]{10}$/, // 10-digit phone number
      zipcode: /^[0-9]{5,6}$/, // ZIP code validation (5-6 digits)
      url: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?$/, // URL validation
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Simple email validation
      numeric: /^[0-9]+$/, // Numeric values
      swiftCode: /^[A-Z0-9]{8,11}$/, // SWIFT code (8 or 11 alphanumeric characters)
      skypeId: /^[a-zA-Z][a-zA-Z0-9._-]{5,31}$/, // Skype ID validation
    };
  
    const newErrors = {};
  
    fieldsToValidate.forEach((field) => {
      const value = formData[field];
  
      // Required field validation
      if (!value) {
        newErrors[field] = `${field.replace(/_/g, " ")} is required`;
        return;
      }
  
      // Custom validation for specific fields
      if (field === "bank_account_no" && !patterns.numeric.test(value)) {
        newErrors[field] = "Bank account number must be numeric.";
      }
  
      if (field === "bank_swift" && !patterns.swiftCode.test(value)) {
        newErrors[field] = "Invalid SWIFT code. Must be 8-11 alphanumeric characters.";
      }
  
      if (field === "manager_skype_id" && !patterns.skypeId.test(value)) {
        newErrors[field] = "Invalid Skype ID.";
      }
  
      if (field === "company_zipcode" && !patterns.zipcode.test(value)) {
        newErrors[field] = "Invalid ZIP code. Must be 5 or 6 digits.";
      }
  
      if (field === "bank_country" && value.length < 2) {
        newErrors[field] = "Bank country must be at least 2 characters long.";
      }
  
      if (field === "website_url" && !patterns.url.test(value)) {
        newErrors[field] = "Invalid website URL.";
      }
  
      if (["manager_email", "contactemail"].includes(field) && !patterns.email.test(value)) {
        newErrors[field] = "Invalid email address.";
      }
    });
  
    return newErrors;
  };
  

  return (
    <>
      {/* Breadcrumb and title */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <Link to={"/dashboard/overview"}><FontAwesomeIcon icon={faHome} /></Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Edit Application</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Edit Application</h4>
        </div>
      </div>

      {/* Main card container */}
      <Card border="light" className="bg-white mb-4">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
              <Row>
                <Col lg={3}>
                  <Nav
                    fill
                    variant="pills"
                    className="flex-column vertical-tab"
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="Merchant">
                        Merchant Application Status
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Company">
                        Company Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Website">
                        Website Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Manager">
                        Manager Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Customer">
                        Customer Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Processing">
                        Processing History
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Transaction">
                        Transaction Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Bank">Bank Information</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Other">Other Information</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>

                <Col lg={9}>
                  <Tab.Content>
                    <Tab.Pane eventKey="Merchant">
                      <Form.Group>
                        <Form.Label>Merchant Type</Form.Label>
                        <Form.Select
                          name="user_type"
                          value={formData.user_type}
                          onChange={handleChange}
                        >
                          <option value="0">Administrator</option>
                          <option value="1">Merchant</option>
                          <option value="2">Manager</option>
                          <option value="3">Third Party Vendor</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.user_type}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Application Status</Form.Label>
                        <Form.Select
                          name="application_status"
                          value={formData.application_status}
                          onChange={handleChange}
                        >
                          <option value="0">Application Approved</option>
                          <option value="1">Application Declined</option>
                          <option value="2">Application Suspended</option>
                          <option value="3">Incomplete Application</option>
                          <option value="4">Waiting For Merchant</option>
                          <option value="5">Waiting For Bank</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.application_status}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <div className="d-flex justify-content-between mt-3">
                        <Button variant="primary" onClick={handleNextClick}>
                          Next <FontAwesomeIcon icon={faArrowRight} />
                        </Button>
                      </div>
                    </Tab.Pane>

                    {/* Company Tab */}
                    <Tab.Pane eventKey="Company">
                      <Form>
                        {/* Add more fields as needed */}

                        <Row>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Name">
                              <Form.Label>Company Name</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                name="company_name"
                                placeholder="Enter company name"
                                value={formData.company_name}
                                onChange={handleChange}
                                isInvalid={!!errors.company_name} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.company_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Address">
                              <Form.Label>Company Address</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter company address"
                                name="company_address"
                                value={formData.company_address}
                                onChange={handleChange}
                                isInvalid={!!errors.company_address} // Add error check
                              />
                            </Form.Group>
                            <Form.Control.Feedback type="invalid">
                              {errors.company_address}
                            </Form.Control.Feedback>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="City">
                              <Form.Label>Company City/Town</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter company city/town"
                                name="company_city"
                                value={formData.company_city}
                                onChange={handleChange}
                                isInvalid={!!errors.company_city} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.company_city}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="State">
                              <Form.Label>Company State</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter company state"
                                name="company_state"
                                value={formData.company_state}
                                onChange={handleChange}
                                isInvalid={!!errors.company_state} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.company_state}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Zipcode">
                              <Form.Label>Company Zipcode</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter company zipcode"
                                name="company_zipcode"
                                value={formData.company_zipcode}
                                onChange={handleChange}
                                isInvalid={!!errors.company_zipcode} // Add error check
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-4">
                            <Form.Group id="Country">
                              <Form.Label>Company Country</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter company country"
                                name="company_country"
                                value={formData.company_country}
                                onChange={handleChange}
                                isInvalid={!!errors.company_country} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.company_country}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Website Tab */}
                    <Tab.Pane eventKey="Website">
                      <Form>
                        {/* Website information fields */}
                        <Col md={12} className="mb-3">
                          <Form.Group id="websiteurl">
                            <Form.Label>Website URL</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter website url"
                              name="website_url"
                              value={formData.website_url}
                              onChange={handleChange}
                              isInvalid={!!errors.website_url} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.website_url}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="Address">
                            <Form.Label>Product/Service</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter product/service"
                              name="product"
                              value={formData.product}
                              onChange={handleChange}
                              isInvalid={!!errors.product} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.product}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="Descriptor">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter descriptor"
                              name="descriptor"
                              value={formData.descriptor}
                              onChange={handleChange}
                              isInvalid={!!errors.descriptor} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.descriptor}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <hr />
                        <Row>
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Manager Tab */}
                    <Tab.Pane eventKey="Manager">
                      <Form>
                        {/* Manager information fields */}

                        <Row>
                          <Col md={6} className="mb-3">
                            <Form.Group id="FullName">
                              <Form.Label>Full Name</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter full name"
                                name="manager_full_name"
                                value={formData.manager_full_name}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_full_name} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_full_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="MAddress">
                              <Form.Label> Address</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter  address"
                                name="manager_address"
                                value={formData.manager_address}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_address} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_address}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Citytown">
                              <Form.Label> City/Town</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter  city/town"
                                name="manager_city"
                                value={formData.manager_city}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_city} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_city}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="MState">
                              <Form.Label> State</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter  state"
                                name="manager_state"
                                value={formData.manager_state}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_state} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_state}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="MZipcode">
                              <Form.Label>Company Zipcode</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter zipcode"
                                name="manager_zipcode"
                                value={formData.manager_zipcode}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_zipcode} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_zipcode}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-4">
                            <Form.Group id="Cellphone">
                              <Form.Label>Cell Phone</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter cell phone"
                                name="manager_phone"
                                value={formData.manager_phone}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_phone} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_phone}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-4">
                            <Form.Group id="Alternatephone">
                              <Form.Label>Alternate Phone</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter alternate  phone"
                                name="manager_AltPhone"
                                value={formData.manager_AltPhone}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_AltPhone} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_AltPhone}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-4">
                            <Form.Group id="Emailadd">
                              <Form.Label>Email Address</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter email address"
                                name="manager_email"
                                value={formData.manager_email}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_email} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_email}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Skypeid">
                              <Form.Label>Skype Id</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter Skype id"
                                name="manager_skype_id"
                                value={formData.manager_skype_id}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_skype_id} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_skype_id}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Passportid">
                              <Form.Label>Passport / Driver ID#</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter passport / driver ID#"
                                name="manager_passport"
                                value={formData.manager_passport}
                                onChange={handleChange}
                                isInvalid={!!errors.manager_passport} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.manager_passport}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="ssnein">
                              <Form.Label>SSN / EIN</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter SSN / EIN"
                                value={formData.SSN}
                                name="SSN"
                                onChange={handleChange}
                                isInvalid={!!errors.SSN} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.SSN}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Customer Tab */}
                    <Tab.Pane eventKey="Customer">
                      <Form>
                        {/* Customer information fields */}

                        <Row>
                          <Col md={12} className="mb-3">
                            <Form.Group id="contactname">
                              <Form.Label>Contact Name</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter contact name"
                                value={formData.contactname}
                                onChange={handleChange}
                                name="contactname"
                                isInvalid={!!errors.contactname} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.contactname}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={12} className="mb-3">
                            <Form.Group id="tollfreeno">
                              <Form.Label>Toll Free Number</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter toll free number"
                                value={formData.tollfreeno}
                                onChange={handleChange}
                                name="tollfreeno"
                                isInvalid={!!errors.tollfreeno} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.tollfreeno}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={12} className="mb-3">
                            <Form.Group id="contactemail">
                              <Form.Label>Contact Email</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter contact Email"
                                value={formData.contactemail}
                                name="contactemail"
                                onChange={handleChange}
                                isInvalid={!!errors.contactemail} // Add error check
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.contactemail}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Processing Tab */}
                    <Tab.Pane eventKey="Processing">
                      <Form>
                        {/* Processing information fields */}

                        <Row>
                          <Col md={6} className="mb-3">
                            <Form.Group id="merchants">
                              <Form.Label>
                                Do You Currently Accept Credit Cards
                              </Form.Label>
                              <Form.Select
                                defaultValue="0"
                                value={formData.credit_card}
                                onChange={handleChange}
                                name="credit_card"
                                isInvalid={!!errors.credit_card} // Add error chec
                              >
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors.credit_card}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="merchants">
                              <Form.Label>
                                Have You Ever Processed Before
                              </Form.Label>
                              <Form.Select
                                defaultValue="0"
                                value={formData.processed_before}
                                onChange={handleChange}
                                name="processed_before"
                                isInvalid={!!errors.processed_before} // Add error chec
                              >
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors.processed_before}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="merchants">
                              <Form.Label>
                                Have You Ever Had Merchant Account Terminated
                              </Form.Label>
                              <Form.Select
                                defaultValue="0"
                                value={
                                  formData.merchant_account_termination_status
                                }
                                onChange={handleChange}
                                name="merchant_account_termination_status"
                                isInvalid={
                                  !!errors.merchant_account_termination_status
                                } // Add error chec
                              >
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors.merchant_account_termination_status}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="contactname">
                              <Form.Label>
                                If Yes Please State The Reason
                              </Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter please state the reason"
                                value={
                                  formData.merchant_account_termination_reason
                                }
                                onChange={handleChange}
                                name="merchant_account_termination_reason"
                                isInvalid={
                                  !!errors.merchant_account_termination_reason
                                } // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.merchant_account_termination_reason}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="tollfreeno">
                              <Form.Label>
                                Former / Current Processor
                              </Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter former / current processor"
                                value={formData.processor}
                                onChange={handleChange}
                                name="processor"
                                isInvalid={!!errors.processor} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.processor}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="contactemail">
                              <Form.Label>Time With Processor</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter time with processor"
                                value={formData.time_with_processor}
                                onChange={handleChange}
                                name="time_with_processor"
                                isInvalid={!!errors.time_with_processor} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.time_with_processor}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Transaction Tab */}
                    <Tab.Pane eventKey="Transaction">
                      <Form>
                        {/* Transaction information fields */}

                        <Row>
                          <Col md={12} className="mb-3">
                            <Form.Group id="websiteurl">
                              <Form.Label>
                                Estimated Total Sales/Month
                              </Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter estimated total sales/Month"
                                value={formData.total_sales}
                                onChange={handleChange}
                                name="total_sales"
                                isInvalid={!!errors.total_sales} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.total_sales}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={12} className="mb-3">
                            <Form.Group id="Address">
                              <Form.Label>
                                Number Of Transactions/Month
                              </Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter number of transactions/month"
                                value={formData.no_of_trans_per_mnth}
                                onChange={handleChange}
                                name="no_of_trans_per_mnth"
                                isInvalid={!!errors.no_of_trans_per_mnth} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.no_of_trans_per_mnth}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={12} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Minimum Ticket Amount</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter minimum ticket amount"
                                value={formData.minimum_ticket_amount}
                                onChange={handleChange}
                                name="minimum_ticket_amount"
                                isInvalid={!!errors.minimum_ticket_amount} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.minimum_ticket_amount}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={12} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Maximum Ticket Amount</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                name="maximum_ticket_amount"
                                placeholder="Enter maximum ticket amount"
                                value={formData.maximum_ticket_amount}
                                onChange={handleChange}
                                isInvalid={!!errors.maximum_ticket_amount} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.maximum_ticket_amount}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>
                    {/* Bank Tab */}
                    {/* <Tab.Pane eventKey="Bank">
                      <Form.Group>
                        <Form.Label>Bank Account Number</Form.Label>
                        <Form.Control name="bank_account_number" value={formData.bank_account_number} onChange={handleChange} />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Bank Name</Form.Label>
                        <Form.Control name="bank_name" value={formData.bank_name} onChange={handleChange} />
                      </Form.Group>
                      <div className="d-flex justify-content-between mt-3">
                        <Button variant="primary" onClick={handlePreviousClick}><FontAwesomeIcon icon={faArrowLeft} /> Previous</Button>
                        <Button variant="primary" onClick={handleNextClick}>Next <FontAwesomeIcon icon={faArrowRight} /></Button>
                      </div>
                    </Tab.Pane> */}

                    <Tab.Pane eventKey="Bank">
                      <Form>
                        {/* Bank information fields */}

                        <Row>
                          <Col md={6} className="mb-3">
                            <Form.Group id="websiteurl">
                              <Form.Label>Account Holder Name</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter account holder name"
                                value={formData.account_holder_name}
                                name="account_holder_name"
                                onChange={handleChange}
                                isInvalid={!!errors.account_holder_name} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.account_holder_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Address">
                              <Form.Label>Account Holder Address</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter account holder address"
                                value={formData.account_holder_address}
                                name="account_holder_address"
                                onChange={handleChange}
                                isInvalid={!!errors.account_holder_address} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.account_holder_address}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Account Holder Country</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter account holder country"
                                value={formData.account_holder_country}
                                name="account_holder_country"
                                onChange={handleChange}
                                isInvalid={!!errors.account_holder_country} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.account_holder_country}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Bank Name</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter bank name"
                                value={formData.bank_name}
                                name="bank_name"
                                onChange={handleChange}
                                isInvalid={!!errors.bank_name} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.bank_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          {/* <Col md={6} className="mb-3">
                               <Form.Group id="Descriptor">
                                 <Form.Label>Bank Name</Form.Label>
                                 <Form.Control required type="text" placeholder="Enter bank name" />
                               </Form.Group>
                             </Col> */}
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Bank Address</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter bank address"
                                value={formData.bank_address}
                                name="bank_address"
                                onChange={handleChange}
                                isInvalid={!!errors.bank_address} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.bank_address}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Bank Country</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter bank country"
                                value={formData.bank_country}
                                name="bank_country"
                                onChange={handleChange}
                                isInvalid={!!errors.bank_country} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.bank_country}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Bank SWIFT</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter bank SWIFT"
                                value={formData.bank_swift}
                                name="bank_swift"
                                onChange={handleChange}
                                isInvalid={!!errors.bank_swift} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.bank_swift}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Bank Routing Number</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter bank routing number"
                                value={formData.bank_routing_no}
                                name="bank_routing_no"
                                onChange={handleChange}
                                isInvalid={!!errors.bank_routing_no} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.bank_routing_no}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Bank Account Number</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter bank account number"
                                value={formData.bank_account_no}
                                name="bank_account_no"
                                onChange={handleChange}
                                isInvalid={!!errors.bank_account_no} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.bank_account_no}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Additional Information</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter additional information"
                                value={formData.bank_additional_info}
                                name="bank_additional_info"
                                onChange={handleChange}
                                isInvalid={!!errors.bank_additional_info} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.bank_additional_info}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Other Tab */}
                    <Tab.Pane eventKey="Other">
                      <Form>
                        {/* Other information fields */}

                        <Row>
                          <Col md={12} className="mb-3">
                            <Form.Group id="websiteurl">
                              <Form.Label>
                                How Did You Hear About Us?
                              </Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter how did you hear about us?"
                                value={formData.about_us}
                                name="about_us"
                                onChange={handleChange}
                                isInvalid={!!errors.about_us} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.about_us}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={12} className="mb-3">
                            <Form.Group id="Address">
                              <Form.Label>Name Of Agent</Form.Label>
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter name of agent"
                                value={formData.agent_name}
                                name="agent_name"
                                onChange={handleChange}
                                isInvalid={!!errors.agent_name} // Add error chec
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.agent_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleSubmit}>
                              Save{" "}
                              <FontAwesomeIcon
                                icon={faThumbsUp}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Form>
        </Card.Body>
      </Card>

      <Container
        fluid
        style={{
          padding: "20px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
      >
        {/* Displaying Messages */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            maxHeight: "300px", // Restrict height of the message area
            overflowY: "auto", // Enable vertical scrolling
            overflowX: "hidden", // Prevent horizontal scrolling
            backgroundColor: "#f8f9fa",
            borderRadius: "8px 8px 0 0",
            padding: "1rem",
          }}
          id="messageContainer"
        >
         <style>
        {`





            #messageContainer {
                scrollbar-color: #007bff #f1f1f1; /* Custom scrollbar for Firefox */
                scrollbar-width: thin; /* Thin scrollbar */
              }

              #messageContainer::-webkit-scrollbar {
                width: 10px;
              }

              #messageContainer::-webkit-scrollbar-thumb {
                background: #007bff; /* Scrollbar thumb color */
                border-radius: 10px;
                border: 2px solid #f1f1f1; /* Adds padding around the thumb */
              }

              #messageContainer::-webkit-scrollbar-track {
                background: #f1f1f1; /* Scrollbar track color */
              }

              .chat-message {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                max-width: 75%;
                margin-bottom: 12px;
              }

              .chat-message.sent {
                align-items: flex-end;
                margin-left: auto;
              }

              .message-bubble {
                background-color: #e8f5ff; /* Light blue for received messages */
                color: #333;
                padding: 12px 16px;
                border-radius: 18px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                font-size: 14px;
                line-height: 1.5;
                word-wrap: break-word;
                position: relative;
              }

              .chat-message.sent .message-bubble {
                background-color: #007bff; /* Blue for sent messages */
                color: #fff;
              }

              .message-bubble::after {
                content: "";
                position: absolute;
                bottom: 0;
                left: -8px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 8px 8px 0 0;
                border-color: #e8f5ff transparent transparent transparent;
                transform: translateY(100%);
              }

              .chat-message.sent .message-bubble::after {
                left: auto;
                right: -8px;
                border-color: #007bff transparent transparent transparent;
              }

              .message-timestamp {
                font-size: 12px;
                color: #666;
                margin-top: 6px;
                text-align: right;
              }

              .sender-name {
                font-size: 12px;
                font-weight: bold;
                color: #007bff;
                margin-bottom: 4px;
              }






      #messageContainer {
        scrollbar-color: #002c55 #e9ecef; /* Thumb and track color for Firefox */
        scrollbar-width: thin; /* Thinner scrollbar */
      }
      
      #messageContainer::-webkit-scrollbar {
        width: 12px; /* Increase width for better visibility */
      }
      
      #messageContainer::-webkit-scrollbar-thumb {
        background: #002c55; /* Thumb color */
        border-radius: 20px; /* Add noticeable rounded corners */
        border: 3px solid #e9ecef; /* Add padding to the thumb with a border */
      }
      
      #messageContainer::-webkit-scrollbar-track {
        background: #e9ecef; /* Track color */
        border-radius: 20px; /* Rounded corners for the track */
      }
      
        `}

      </style>
      
      
      
          {/* Function to format dates */}
          {formatMessages(messages).map((group, index) => (
            <div key={index}>
              {/* Display date heading */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Center the heading
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    display: "inline-block", // Make the width fit the text only
                    backgroundColor: "#e9ecef",
                    fontWeight: "bold",
                    color: "#6c757d",
                    fontSize: "16px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                  }}
                >
                  {group.date}
                </div>
              </div>
      
              {/* Displaying individual messages in each group */}
              {group.messages.map((message) => (
                
                
                <div
                  key={message.id}
                  style={{
                    display: "flex",
                    justifyContent: message.sender ? "flex-end" : "flex-start",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      padding: "10px",
                      borderRadius: "8px",
                      maxWidth: "75%", // Prevent messages from stretching beyond container width
                      backgroundColor: message.sender ? "#002c55" : "#002c55",
                      color: message.sender ? "#fff" : "#fff",
                      wordWrap: "break-word", // Ensure long words break into the next line
                    }}
                  >


                     {/* {message.sender && (
                     
                      )} */}


                    <p style={{ marginBottom: "0" }}>
                    {message.text}
                    </p>
                    <div style={{display:'flex',gap:'1rem'}}>
                          <small style={{ color: "#6c757d" }}>
                            {new Date(message.time).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}

                          </small>
                          <small
                                style={{
                                  fontWeight: "bold",
                                  display: "block",
                                  color: "#6c757d"
                                }}
                              >
                                {message.senderName || "Unknown "}
                              </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      
        {/* Input for New Message */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            padding: "12px",
            borderTop: "1px solid #ddd",
            borderRadius: "0 0 8px 8px",
          }}
        >
          <input
            type="text"
            placeholder="Type your message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") handleSendMessage(); // Send on Enter
            }}
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
          />
          <button
            onClick={handleSendMessage}
            style={{
              padding: "10px 16px",
              borderRadius: "4px",
              border: "1px solid #007bff",
              backgroundColor: "#002c55",
              color: "#fff",
              marginLeft: "8px",
              cursor: "pointer",
            }}
          >
            Send
          </button>
        </div>
      </Container>



          {userType == 0 || userType == 1 ? (
  <UpdateApplicationStatus
    applicationId={id}
    applicationData={applicationData} // Pass the current application data
    onStatusUpdate={handleStatusUpdate}
  />
) : " "}
    
        </>
  );
};

export default EditApplication;
